import { TaskItem } from '../../core';

import { groups } from './const/view-groups.const';
import { groupItems } from './function/group-items.function';
import { FilterOptions } from './model/filter-options.model';
import { OrderBy } from './model/order-by.model';
import { ViewGroup } from './model/view-group.model';

export interface TaskListDialogState {
    pending: {
        reload?: boolean;
    };
    searchOpen?: boolean;
    filterOpts: FilterOptions;
    filterIsDefault?: { search?: boolean; filter?: boolean };
    orderBy: OrderBy;
    tasks?: TaskItem[];
    groups?: ViewGroup[];
}

export const defaultState = (): TaskListDialogState => ({
    pending: {},
    groups: groupItems(groups, []),
    filterOpts: {
        status: { important: false },
        dateRange: {
            from: null,
            to: null,
        },
        minDate: null,
        maxDate: null,
    },
    orderBy: OrderBy.DUE_DATE_ASC,
});
